import { Component, Input } from '@angular/core';
import { LDWDocument } from '../../models/LDWDocument';
import { AppUrls } from '../../../route/app-urls';

@Component({
    selector: 'ldw-document-images',
    templateUrl: './document-images.component.html',
    styleUrls: ['./document-images.component.css'],
    standalone: false
})
export class DocumentImagesComponent {
  @Input() document: LDWDocument | undefined = undefined;

  get images(): string[] {
    if (this.document == undefined) {
      return [];
    }
    return this.document.images;
  }

  getImageUrl(image: string): string {
    return AppUrls.getImageUrl(image);
  }
}
